export function timeline({ start, end, marker = 0, beforeCalc, afterCalc }) {
	
	const tl = { start: 0, end: 0, length: 0, marker: 0 }
	const pos = { scroll: 0, pixels: 0, percent: 0 }
	
	function calculate() {
		beforeCalc && beforeCalc()
		tl.start = start()
		tl.end = end()
		tl.length = tl.end - tl.start
		tl.marker = minmax(0, window.innerHeight, window.innerHeight * marker)
		afterCalc && afterCalc()
	}

	function position() {
		pos.scroll = window.scrollY + tl.marker
		pos.pixels = minmax(0, tl.end - tl.start, pos.scroll - tl.start)
		const percent = inverseLerp(tl.start, tl.end, pos.scroll)
		pos.percent = minmax(0, 1, percent)
		pos.percentRaw = percent
		return pos
	}

	const callbacks = []
	function addCallback(fn) {
		callbacks.push(fn)
	}

	function runCallbacks() {
		const pos = position()
		callbacks.map(fn => fn(pos, tl))
	}

	function calcAndRunCallbacks() {
		calculate()
		runCallbacks()
	}

	let id
	function onScroll(event) {
		if (id) return
		id = window.requestAnimationFrame(() => {
			window.cancelAnimationFrame(id)
			id = false
			runCallbacks()
		})
	}

	function setupEvents() {
		window.addEventListener('DOMContentLoaded', calcAndRunCallbacks)
		window.addEventListener('resize', calcAndRunCallbacks)
		window.addEventListener('scroll', onScroll)
	}

	function removeEvents() {
		window.removeEventListener('DOMContentLoaded', calcAndRunCallbacks)
		window.removeEventListener('resize', calcAndRunCallbacks)
		window.removeEventListener('scroll', onScroll)
	}

	// init
	setupEvents()
	calcAndRunCallbacks()
	
	return {
		onUpdate: addCallback,
		update: calcAndRunCallbacks,
		end: removeEvents
	}
}

function minmax(min, max, value) {
	return Math.max(min, Math.min(value, max))
}

function inverseLerp(a, b, v) {
	return (v - a) / (b - a) || 0
}

/* 
 * get the pixel position of an element relative to the viewport 
 * elementX (0 = left, 1 = right)
 * elementY (0 = top, 1 = bottom)
 * viewportX (0 = left, 1 = right)
 * viewportY (0 = top, 1 = bottom)
 */

export function positionInViewport(el, options) {
	
	const { 
		elementX = 0,
		elementY = 0,
		viewportX = 0,
		viewportY = 0
	} = options

	const rect = el.getBoundingClientRect()

	const windowWidth = window.innerWidth
	const windowHeight = window.innerHeight
	
	const x = (
		window.scrollX 
		+ rect.left 
		+ (rect.width * elementX) 
		- (windowWidth * viewportX)
	)
	const xPercent = x/windowWidth

	const y = (
		window.scrollY 
		+ rect.top 
		+ (rect.height * elementY) 
		- (window.innerHeight * viewportY)
	)

	const yPercent = y/windowHeight
	
	return {
		x, y, xPercent, yPercent
	}
}